import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableFilters, TableFiltersState } from './types/tableFilters.type';

export const TABLE_PARTES_VALIDATING_ID = 'partesValidating';

const initialState: TableFiltersState = {
  [TABLE_PARTES_VALIDATING_ID]: {
    searchQuery: '',
    selectedFilters: {
      empresa: null,
      obra: null,
      dateFrom: null,
      dateTo: null,
      empleado: null,
      responsable: null,
    },
  },
};

const tableFiltersSlice = createSlice({
  name: 'tableFilters',
  initialState,
  reducers: {
    setTableFilters: (
      state,
      action: PayloadAction<{ tableId: string; filters: TableFilters }>
    ) => {
      state[action.payload.tableId] = action.payload.filters;
    },
    clearTableFilters: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    }
  },
});

export const { setTableFilters, clearTableFilters } =
  tableFiltersSlice.actions;
export default tableFiltersSlice.reducer;
